<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer006">
<p class="PN"><a id="_idTextAnchor003"></a><a href="#/Thiselton_A_Shorter_Guide2#toc3">Part I</a></p>
<p class="PT" id="_idParaDest-4"><a id="_idTextAnchor004"></a><a href="#/Thiselton_A_Shorter_Guide2#toc3">The Spirit in the Biblical Writings</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Thiselton_A_Shorter_Guide-5.vue?2a792936